import { parse } from './querystring'
import toast from './toast'
import Nprogress from 'nprogress'
import {
  getSessionToken,
  getCsrfToken,
  handleSessionExpired
} from 'util/admin-session'
const uuid = require('uuid/v4')

export function getErrorMessage(e, fallback = '操作失败，请重试') {
  if (!e) return fallback
  if (e.message) return e.message
  if (e.error) return e.error
  if (e.type) return `${fallback}：${e.type}`
  if (typeof e === 'string') return e
  try {
    return JSON.stringify(e)
  } catch (error) {
    return fallback
  }
}

export function uploadFile(f) {
  Nprogress.start()
  const form = new FormData()
  form.append('file', f, f.name || uuid().replace(/-/g, ''))
  const headers = {}
  const sessionToken = getSessionToken()
  if (sessionToken) headers['X-YX-Session'] = sessionToken
  const csrfToken = getCsrfToken()
  if (csrfToken) headers['X-CSRF-Token'] = csrfToken
  return new Promise((resolve, reject) => {
    fetch('/upload/content', {
      method: 'POST',
      headers,
      body: form,
      credentials: 'same-origin'
    }).then(res => {
      return res.text().then(text => {
        let body = {}
        if (text) {
          try {
            body = JSON.parse(text)
          } catch (error) {
            body = { error: text }
          }
        }
        if (!res.ok) {
          const error = new Error(body.error || `上传失败(${res.status})`)
          error.status = res.status
          if (handleSessionExpired(error)) {
            error.message = '登录已过期，请重新登录'
          }
          throw error
        }
        return body
      })
    }).then(data => {
      Nprogress.done()
      resolve(data.url)
    }, e => {
      Nprogress.done()
      toast(getErrorMessage(e, '上传失败'), { type: 'error' })
      reject(e)
    })
  })
}

export function onError(e) {
  return toast(getErrorMessage(e), { type: 'error' })
}

export function emptyFn() {}

export function parseUrl(url) {
  let parts = url.split(/\?/)
  return {
    path: parts[0],
    query: parse(parts[1])
  }
}

export function date(str) {
  const d = str instanceof Date ? str : new Date(str)
  let year = d.getFullYear()
  let month = d.getMonth() + 1
  let day = d.getDate()

  return `${year}-${pad(month)}-${pad(day)}`
}

function pad(n) {
  return n < 10 ? `0${n}` : `${n}`
}

export function dateTime(str) {
  let d = new Date(str)
  let day = date(d)
  const hours = d.getHours()
  const minutes = d.getMinutes()
  return `${day} ${pad(hours)}:${pad(minutes)}`
}

export function formatHTML(html) {
  if (!html) return ''
  html = html.replace(/<style([\s\S]*?)<\/style>/gi, '')
  html = html.replace(/<script([\s\S]*?)<\/script>/gi, '')
  html = html.replace(/<\/div>/gi, '\n')
  html = html.replace(/<\/li>/gi, '\n')
  html = html.replace(/<li>/gi, '  *  ')
  html = html.replace(/<\/ul>/gi, '\n')
  html = html.replace(/<\/p>/gi, '\n')
  html = html.replace(/<br\s*[/]?>/gi, '\n')
  html = html.replace(/<[^>]+>/gi, '')
  html = html.replace(/\n{2,}/g, '\n\n')
  html = html.replace(/\n+$/g, '')
  html = html.replace(/&nbsp;/g, ' ')
  return html
}

export const repeats = [
  {
    id: 'no-repeat',
    name: '不重复'
  },
  {
    id: 'repeat-x',
    name: '水平重复'
  },
  {
    id: 'repeat-y',
    name: '垂直重复'
  },
  {
    id: 'repeat',
    name: '平铺'
  }
]

export function getRepeatName(repeat) {
  let obj = repeats.find(o => o.id == repeat)
  if (obj) return obj.name
}

export function imgDimension(file) {
  let fr = new FileReader()
  return new Promise((resolve, reject) => {
    fr.onload = function() {
      let img = new Image()
      img.onload = function() {
        resolve({
          width: img.width,
          height: img.height
        })
      }
      img.onerror = function(err) {
        reject(err)
      }
      img.src = fr.result
    }
    fr.readAsDataURL(file)
  })
}

export function getThumbUrl(url, n) {
  if (!url) return ''
  return `${url}?imageView2/1/w/${n}/h/${n}/q/100/format/jpg`
}

function VoucherSourcetoPrint(source) {
  return (
    '<html><head><script>function step1(){\n' +
    "setTimeout('step2()', 10);}\n" +
    'function step2(){window.print();window.close()}\n' +
    '</scri' +
    "pt></head><body onload='step1()'>\n" +
    "<img src='" +
    source +
    "' /></body></html>"
  )
}

export function printImg (source) {
  let Pagelink = 'about:blank'
  let pwa = window.open(Pagelink, '_new')
  pwa.document.open()
  pwa.document.write(VoucherSourcetoPrint(source))
  pwa.document.close()
}
